module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_0.27e6212a.png";